import React from 'react';
import { constants } from '@eti/utils';
import { etiColors } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import Icon from '../icon/Icon';
import { Wrapper, NotificationIcon, Content, Button, Title } from './styledComponents';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  NOTIFICATION_DEFAULT,
  NOTIFICATION_CLIMATE_COMPENSATION,
  NOTIFICATION_PRICE_DROP_PROTECTION,
  SELF_TRANSFER_GUARANTEE
} = constants.notificationTypes;
const notificationThemes = {
  [NOTIFICATION_DEFAULT]: {
    background: {
      main: '#fff',
      accent: '#dedede'
    }
  },
  [NOTIFICATION_CLIMATE_COMPENSATION]: {
    background: {
      main: '#fff',
      accent: '#f0fff1'
    }
  },
  [NOTIFICATION_PRICE_DROP_PROTECTION]: {
    background: {
      main: '#fff',
      accent: '#98b1ce'
    }
  },
  [SELF_TRANSFER_GUARANTEE]: {
    background: {
      main: '#fff',
      accent: '#a4dea6'
    }
  }
};
const NotificationPanel = _ref => {
  let {
    closeButtonLabel = '',
    className,
    title,
    type = NOTIFICATION_DEFAULT,
    icons,
    dataTestId,
    children,
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const closeButtonLabelText = closeButtonLabel || t('Close');
  return /*#__PURE__*/_jsxs(Wrapper, {
    className: className,
    "data-testid": dataTestId,
    theme: notificationThemes[type],
    children: [onClose && /*#__PURE__*/_jsx(Button, {
      "aria-label": closeButtonLabelText,
      "data-testid": `${dataTestId}-close-button`,
      onClick: onClose,
      children: /*#__PURE__*/_jsx(Icon, {
        color: etiColors.grayScale[9],
        id: "close-menu",
        size: "1rem"
      })
    }), /*#__PURE__*/_jsx(NotificationIcon, {
      icons: icons
    }), /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: title
      }), children]
    })]
  });
};
export default NotificationPanel;
//# sourceMappingURL=NotificationPanel.js.map